<div class="card p-2 p-md-3">
  <div class="row g-3">
    <!-- Element Bio -->
    <div class="col-12 col-md-6">
      <label class="form-label">Element Bio *</label>
      <input type="text" class="form-control" [(ngModel)]="biology.element_Bio" (ngModelChange)="_change()" />
      <span *ngIf="isSubmitted && biology.element_Bio.length == 0" class="text-danger">
        Element bio est obligatoire
      </span>
    </div>

    <!-- Indication Bio -->
    <div class="col-12 col-md-6">
      <label class="form-label">Indication Bio</label>
      <angular-editor [config]="editorConfig" [(ngModel)]="biology.indication_Bio" (ngModelChange)="_change()" class="editor"></angular-editor>
    </div>

    <!-- Norme Bio -->
    <div class="col-12 col-md-6">
      <label class="form-label">Norme Bio</label>
      <input type="text" class="form-control" [(ngModel)]="biology.norme_Bio" (ngModelChange)="_change()" />
    </div>

    <!-- Param Bio -->
    <div class="col-12 col-md-6">
      <label class="form-label">Param Bio</label>
      <input type="text" class="form-control" [(ngModel)]="biology.param_Bio" (ngModelChange)="_change()" />
    </div>
  </div>
</div>
